export default {
    excess: 'Eigen risico',
    security: 'Borgsom',
    fuel_policy: 'Brandstofbeleid',
    like_for_like: 'Zelfde peil terug',
    full_to_full: 'Vol terug',
    mileage: 'Kilometers: {mileage} kilometer per boeking',
    unlimited_mileage: 'Onbeperkte kilometers',
    non_refundable: 'Niet restitueerbaar',
    free_cancellation_until: 'Gratis te annuleren tot {date}',
    cancellation_with_terms: 'Annulering {0} overeenkomstig de ',
    t_c_text: 'Voorwaarden',
    two_free_extras: 'Twee gratis extra\'s bij ophalen',
    glass_tyres_covered: 'Ruiten en banden gedekt'
}
